/**
 * Created by idea on 03/07/2017.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { adminComponent } from './layout/layouts/admin.component';
import { blankComponent } from './layout/layouts/blank.component';


import { LoginComponent } from './pages/admin/auth/login.component';
import { LogoutComponent } from './pages/admin/auth/logout.component';
import { AuthGuard } from './common/services/Auth.guard';

import { Page401Component } from './pages/admin/icontact/page-error/page-401-component';
import { DashboardComponent } from './pages/admin/icontact/dashboard/dashboard.component';
import { ContactsComponent } from './pages/admin/icontact/contact/contacts.component';
import { ReportComponent } from './pages/admin/icontact/report/report.component';
import { ChatComponent } from './pages/admin/icontact/chat/chat.component';
import { SettingsComponent } from './pages/admin/icontact/setting/settings.component';
//import { MailboxComponent } from './pages/admin/icontact/email/mailbox.component';
import { MonitorComponent } from './pages/admin/icontact/monitor/monitor.component';
import { AnalyticComponent } from './pages/admin/icontact/analytic/analytic.component';
import { SearchComponent } from './pages/admin/icontact/search/search.component';
import { CampaignComponent } from './pages/admin/icontact/campaign/campaign.component';
import { CustomerComponent } from './pages/admin/icontact/customer/customer.component';


@NgModule({
    imports: [
        RouterModule.forRoot([
            { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
            {
                path: '', component: adminComponent,
                children: [
                    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
                    { path: 'page-401', component: Page401Component, canActivate: [AuthGuard] },
                    { path: 'contacts', component: ContactsComponent, canActivate: [AuthGuard] },
                    { path: 'report', component: ReportComponent, canActivate: [AuthGuard] },
                    { path: 'chatting', component: ChatComponent, canActivate: [AuthGuard] },
                   // { path: 'facebook', component: FacebookComponent, canActivate: [AuthGuard] },
                    { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard], data: { role : ["administrator", "supervisor"]}  },
                  //  { path: 'mailbox', component: MailboxComponent, canActivate: [AuthGuard] },
                    { path: 'monitor', component: MonitorComponent, canActivate: [AuthGuard], data: { role : ["administrator", "supervisor"]} },
                    { path: 'analytic', component: AnalyticComponent, canActivate: [AuthGuard] },
                    { path: 'search', component: SearchComponent, canActivate: [AuthGuard] },
                    { path: 'campaign', component: CampaignComponent, canActivate: [AuthGuard], data: { role : ["administrator", "supervisor"]} },
                    { path: 'customer', component: CustomerComponent, canActivate: [AuthGuard] }
                ]   
            },
            {
                path: '', component: blankComponent,
                children: [
                    { path: 'login', component: LoginComponent },
                    { path: 'logout', component: LogoutComponent }
                ]
            }
        ])
    ],
    exports: [RouterModule]
})
export class AppAdminRoutingModule { }




// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/app-admin.routes.ts